import React from 'react';
import './Privacy.css'; // Use its own CSS file
import Container from 'react-bootstrap/Container';

export default function Privacy() {
    return (
        <Container as="main" className="privacy-page">
            <h1 className="page-title d-flex justify-content-center flex-nowrap">
                Privacy Policy
            </h1>
            <div className="page-content">
                <p>
                    <strong>Last Updated: March 20, 2025</strong>
                </p>
                <p>
                    At Lumiwealth, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://botspot.trade">https://botspot.trade</a> and <a href="https://lumiwealth.com">https://lumiwealth.com</a>, including any other media form, media channel, mobile website, or mobile application related or connected thereto (collectively, the "Site").
                </p>
                <h2>1. Collection of Your Information</h2>
                <p>
                    We may collect information about you in a variety of ways. The information we may collect via the Site includes:
                </p>
                <h3>Personal Data</h3>
                <p>
                    Personally identifiable information, such as your name, email address, and telephone number, that you voluntarily give to us when you register with the Site or when you choose to participate in various activities related to the Site. You are under no obligation to provide us with personal information of any kind, however your refusal to do so may prevent you from using certain features of the Site.
                </p>
                <h3>Derivative Data</h3>
                <p>
                    Information our servers automatically collect when you access the Site, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the Site.
                </p>
                <h3>Financial Data</h3>
                <p>
                    Financial information, such as data related to your payment method (e.g., valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services from the Site. We store only very limited, if any, financial information that we collect. Otherwise, all financial information is stored by our payment processor, Stripe, and you are encouraged to review their privacy policy and contact them directly for responses to your questions.
                </p>
                <h2>2. Use of Your Information</h2>
                <p>
                    Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:
                </p>
                <ul>
                    <li>Create and manage your account.</li>
                    <li>Process your payments and refunds.</li>
                    <li>Email you regarding your account or order.</li>
                    <li>Fulfill and manage purchases, orders, payments, and other transactions related to the Site.</li>
                    <li>Increase the efficiency and operation of the Site.</li>
                    <li>Monitor and analyze usage and trends to improve your experience with the Site.</li>
                    <li>Notify you of updates to the Site.</li>
                    <li>Resolve disputes and troubleshoot problems.</li>
                </ul>
                <h2>3. Disclosure of Your Information</h2>
                <p>
                    We may share information we have collected about you in certain situations. Your information may be disclosed as follows:
                </p>
                <h3>By Law or to Protect Rights</h3>
                <p>
                    If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.
                </p>
                <h3>Third-Party Service Providers</h3>
                <p>
                    We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.
                </p>
                <h2>4. Security of Your Information</h2>
                <p>
                    We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
                </p>
                <h2>5. Policy for Children</h2>
                <p>
                    We do not knowingly solicit information from or market to children under the age of 13. If you become aware of any data we have collected from children under age 13, please contact us using the contact information provided below.
                </p>
                <h2>6. Options Regarding Your Information</h2>
                <h3>Account Information</h3>
                <p>
                    You may at any time review or change the information in your account or terminate your account by:
                </p>
                <ul>
                    <li>Logging into your account settings and updating your account.</li>
                    <li>Contacting us using the contact information provided below.</li>
                </ul>
                <p>
                    Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, some information may be retained in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with legal requirements.
                </p>
                <h2>7. Contact Us</h2>
                <p>
                    If you have questions or concerns about this Privacy Policy, please contact us at:
                </p>
                <p>
                    Lumiwealth, Inc.<br />
                    Email: <a href="mailto:support@lumiwealth.com">support@lumiwealth.com</a>
                </p>
            </div>
        </Container>
    );
}
